export default __webpack_public_path__ + "static/media/RestoLogo1.1.334dbca8.png";